import axios from 'axios';

// YKBaseAPI Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add any auth tokens if needed
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
    }
    return Promise.reject(error);
  }
);

// API Methods
export const apiService = {
  // GET request
  get: (url, config = {}) => apiClient.get(url, config),

  // POST request
  post: (url, data, config = {}) => apiClient.post(url, data, config),

  // PUT request
  put: (url, data, config = {}) => apiClient.put(url, data, config),

  // DELETE request
  delete: (url, config = {}) => apiClient.delete(url, config),

  // PATCH request
  patch: (url, data, config = {}) => apiClient.patch(url, data, config),
};

export default apiService;
